import { ConfirmAccountView } from './ConfirmAccountView';
import { changeView as _changeView } from '../../actions/view';
import { authenticateByToken as _authenticateByToken } from '../../actions/phoneAuth';
import { connect } from 'react-redux';
export function mapStateToProps(state) {
  return {
    status: state.phoneAuth.authenticateByToken.status,
    email: state.phoneAuth.authenticateByToken.account,
    error: state.phoneAuth.authenticateByToken.error,
    source: state.source
  };
}
export function mapDispatchToProps(dispatch) {
  return {
    changeView: function changeView(view, data) {
      dispatch(_changeView(view, data));
    },
    authenticateByToken: function authenticateByToken(params) {
      dispatch(_authenticateByToken(params));
    }
  };
}
export var ConfirmAccountViewContainer = connect(mapStateToProps, mapDispatchToProps)(ConfirmAccountView);